import {Link, useParams} from 'react-router-dom';

import {AuthCardLayout} from "@layouts/AuthCardLayout";
import "../pages/SignupPage.css";

export function ConnectToIntegration() {
    const {slug} = useParams<{ slug: string }>()
    const integrationName = slug;

    return (
        <AuthCardLayout>
            <div className="signup-container">
                <div className="logo">P</div>

                <div className="signup-header">
                    <h1>Welcome!</h1>
                    <p>Your Pecunio account is now active</p>
                </div>

                <p style={{ color: '#666', fontSize: '15px', marginBottom: '30px', lineHeight: 1.5 }}>
                    Next, let's connect to your {integrationName} account to unlock the
                    full potential of Pecunio AI
                </p>

                <a href="/api/integrations/xero/login" style={{ textDecoration: 'none' }}>
                    <button type="button" className="signup-btn">
                        Connect to {integrationName}
                    </button>
                </a>

                <div className="login-link">
                    <Link to="/dashboard">Skip for now</Link>
                </div>
            </div>
        </AuthCardLayout>
    );
}

export default ConnectToIntegration;
